/*NOW DETERMINE IF it's a DEALER'S CUSTOMER THAT IS SHOPPING*/
  var validDealers = ["midt-finnmark", "polaris-nordmore", "fs-yamaha", "argyll", "ralphs", "precision", "other"];
  var dealerAjaxSent=false;

  if( getUrlParam('utm_source') == 'dealer'){//if url contains dealer info, check if valid
    customerDealer=getUrlParam("utm_campaign");
    customerDealer=customerDealer && validDealers.includes(customerDealer) ? customerDealer : false;
    if(customerDealer){//if dealer info in url param is valid, save to dealer cookie, fetch details by ajax, set flag that we did ajax retrieve
      Cookies.set('customerDealer', customerDealer, {
        expires: 1
      });
      dealerAjaxSent=true;
      fetchDealerData(customerDealer);    
    }
    else customerDealerCookieToDefault();//if invalid, clear all
  }

  //function to get dealer data
  function fetchDealerData(theDealer){
    $.ajax({
      url: 'https://fxrracing.net/dealer-sites/get-dealer-info.php', //This is the current doc
      type: "POST",
      data: ({dealerHandle: theDealer}),
      success: function(data){
        var dealerInfo = jQuery.parseJSON(data);
        localStorage.setItem("customerDealerDealer", dealerInfo.info.dealer);
        localStorage.setItem("customerDealerLogo", dealerInfo.info.logo);
        localStorage.setItem("customerDealerPhoto", dealerInfo.info.photo);
        localStorage.setItem("customerDealerPhotoTeam", dealerInfo.info["photo-team"]);
        localStorage.setItem("customerDealerWordmark", dealerInfo.info.wordmark);
        localStorage.setItem("customerDealerHtml", dealerInfo.info.html);
        localStorage.setItem("customerDealerHtmlLocal", dealerInfo.info["html-local-language"]);

        customerDealerDealer=localStorage.getItem('customerDealerDealer');
        customerDealerLogo=localStorage.getItem("customerDealerLogo");
        customerDealerPhoto=localStorage.getItem("customerDealerPhoto");
        customerDealerPhotoTeam=localStorage.getItem("customerDealerPhotoTeam");
        customerDealerWordmark=localStorage.getItem("customerDealerWordmark");
        customerDealerHtml=localStorage.getItem("customerDealerHtml");
        customerDealerHtmlLocal=localStorage.getItem("customerDealerHtmlLocal");
        doDealerReplacements();
      },
      error: function( jqXhr, textStatus, errorThrown ){
          alert( errorThrown );
      }
    });
  }
  //function to reset cookie to default if necessary
  function customerDealerCookieToDefault(){
    cookieCustomerDealer=false;
    Cookies.set('customerDealer', false, {
      expires: 1,
      path: "/"
    });
    localStorage.setItem("customerDealerDealer", null);
    localStorage.setItem("customerDealerLogo", null);
    localStorage.setItem("customerDealerPhoto", null);
    localStorage.setItem("customerDealerPhotoTeam", null);
    localStorage.setItem("customerDealerWordmark", null);
    localStorage.setItem("customerDealerHtml", null);
    localStorage.setItem("customerDealerHtmlLocal", null);
  }
  function doDealerReplacements(){
    if(typeof customerDealerHtml !=='undefined'){
      $("<div style='width:100%; background-color:#efefef; text-align:center; padding:8px; border-bottom:1px solid black;'><a href='/pages/dealer'><img style='height:44px; width:auto; border:0px;' src='"+customerDealerLogo+"'></a></div>").insertBefore('div#shopify-section-header');
      $("div#shopify-section-announcement").hide();
      window.scrollTo(0, 0);
      $( "div.dealerPageContent" ).html( customerDealerHtmlLocal );
      if(customerDealerPhoto.length>7 && customerDealerPhotoTeam.length>7 ) dealerPhotoLayout='dealerImageDouble';
      else dealerPhotoLayout='dealerImageSingle';
      if( customerDealerPhotoTeam.length>7 ) $( "div.dealerPageContent .dealerWriteupWrapper" ).prepend("<div class='dealerImageWrapper dealerImageTeam "+dealerPhotoLayout+"'><img class='dealerWriteupImg' src='"+customerDealerPhotoTeam+"'></div>");
      if( customerDealerPhoto.length>7 )$( "div.dealerPageContent .dealerWriteupWrapper" ).prepend("<div class='dealerImageWrapper dealerImageStore "+dealerPhotoLayout+"'><img class='dealerWriteupImg' src='"+customerDealerPhoto+"'></div>");
    }
    else console.log('dealer info not set!');
    
  }
  
  
  $( document ).ready(function() {
    //if dealer cookies weren't set on this page load, just fetch what we have
    if(!dealerAjaxSent){
      // get the dealer cookie, and if invalid, reset all values including cookie
      cookieCustomerDealer=typeof Cookies.get('customerDealer')==='undefined' ? false : Cookies.get('customerDealer');
      if( !cookieCustomerDealer || !(validDealers.includes(cookieCustomerDealer)) ){
        customerDealerCookieToDefault();
      }
      if(cookieCustomerDealer){//if retrieved cookie is valid, fetch other details from local storage. If local storage is empty, do ajax to retrieve all details
      	customerDealerDealer=localStorage.getItem('customerDealerDealer');
        customerDealerLogo=localStorage.getItem('customerDealerLogo');
        if (typeof customerDealerLogo !== 'string' || customerDealerLogo.length < 3) fetchDealerData(customerDealerDealer)
        else{
          customerDealerLogo=localStorage.getItem("customerDealerLogo");
          customerDealerPhoto=localStorage.getItem("customerDealerPhoto");
          customerDealerPhotoTeam=localStorage.getItem("customerDealerPhotoTeam");
          customerDealerWordmark=localStorage.getItem("customerDealerWordmark");
          customerDealerHtml=localStorage.getItem("customerDealerHtml");
          customerDealerHtmlLocal=localStorage.getItem("customerDealerHtmlLocal");
        }
        doDealerReplacements();//insert all necessary details into page
      }
  	}
  });